import type {
  GetListUserInterfaceConfigurationFiltersType,
  UserInterfaceConfigurationType,
} from "../schemas/UserInterfaceConfigurationsSchemas.ts";
import { fetchAndCollate, getFilterObject } from "../util/index.ts";
import type {
  GetListRequestType,
  GetListResponseType,
  ResourceAdapterType,
} from "../util/index.ts";
import { restAPI } from "./api.ts";

export const UserInterfaceConfigurationAdapter: UserInterfaceConfigurationAdapterType =
  {
    getList: ({ filters, page, pageSize, sortBy, sortDirection }) =>
      fetchAndCollate(
        ({ page, pageSize }) =>
          restAPI.nodeAPI.POST({
            endpoint: "/user_interface_configurations/search",
            body: {
              page,
              page_size: pageSize,
              sort_by: sortBy,
              sort_direction: sortDirection,
              filter: getFilterObject(filters),
            },
          }),
        page,
        pageSize
      ),
    getOne: ({ id }) =>
      restAPI.nodeAPI.GET({
        endpoint: `/user_interface_configurations/${id}`,
      }),
    createOne: ({ data }) =>
      restAPI.nodeAPI.POST({
        endpoint: "/user_interface_configurations",
        body: data,
      }),
    updateOne: ({ id, data }) =>
      restAPI.nodeAPI.PUT({
        endpoint: `/user_interface_configurations/${id}`,
        body: data,
      }),
    deleteOne: ({ id }) =>
      restAPI.nodeAPI.DELETE({
        endpoint: `/user_interface_configurations/${id}`,
      }),
  };

export interface UserInterfaceConfigurationAdapterType
  extends Pick<
    ResourceAdapterType<UserInterfaceConfigurationType>,
    "getList" | "getOne" | "createOne" | "updateOne" | "deleteOne"
  > {
  getList: (
    params: GetListRequestType<GetListUserInterfaceConfigurationFiltersType>
  ) => Promise<GetListResponseType<UserInterfaceConfigurationType>>;
}
